import type { Language } from './landingCopy';
import Wordmark from './Wordmark';

/*
  The two front doors of www.city-seek.com and the one way between them.

  The landing page (for people in the city) and CitySeek Coupons (for the places
  that give the offers) share the same top-left corner: the S mark and the
  CitySeek wordmark always go to the landing page, the Coupons ticket always goes
  to the coupons page, each in the language being read. So either page is one
  click from the other and the language never resets on the way.

  The coupons page keeps its language at the end of the address (/coupons/de),
  the way the platform's own pages carry it (/app/events/<slug>/de). The old
  /de/coupons and /tr/coupons answer with a 301 to these.
*/
export const HOME_PATH: Record<Language, string> = { en: '/landing', de: '/de/', tr: '/tr/' };
export const COUPONS_PATH: Record<Language, string> = { en: '/coupons', de: '/coupons/de', tr: '/coupons/tr' };

/* The product name stays CitySeek; the word after it is said the local way. */
export const COUPONS_WORD: Record<Language, string> = { en: 'Coupons', de: 'Gutscheine', tr: 'Kuponlar' };
export const COUPONS_NAME: Record<Language, string> = { en: 'CitySeek Coupons', de: 'CitySeek Gutscheine', tr: 'CitySeek Kuponları' };
/* The link from the landing page's business sections to the coupons page. */
export const COUPONS_MORE: Record<Language, string> = {
 en: 'More about Coupons for local businesses',
 de: 'Mehr über Gutscheine für lokale Betriebe',
 tr: 'Yerel işletmeler için Kuponlar hakkında',
};

/** Language from a coupons address, old shape included. */
export function couponsLanguage(pathname: string): Language {
 const path = pathname.replace(/\/+$/, '').toLowerCase();
 if (path === '/coupons/de' || path === '/de/coupons') return 'de';
 if (path === '/coupons/tr' || path === '/tr/coupons') return 'tr';
 return 'en';
}

export default function SiteBrand({ language, current }: { language: Language; current: 'home' | 'coupons' }) {
 return <div className="cs-brand">
  <a className="cs-logo" href={HOME_PATH[language]} aria-label="CitySeek" aria-current={current === 'home' ? 'page' : undefined}>
   <img className="cs-logo-mark" src="/brand/cityseek-mark.webp" width="180" height="236" alt="" />
   <Wordmark />
  </a>
  <a className="cs-coupons-tag" href={COUPONS_PATH[language]} lang={language} aria-current={current === 'coupons' ? 'page' : undefined}>
   <span className="cs-coupons-ticket">
    <span className="cs-coupons-coin" aria-hidden="true" />
    <span className="cs-coupons-word">{COUPONS_WORD[language]}</span>
   </span>
  </a>
 </div>;
}
